import type { ZFilterGroup } from "src/business/queryBuilder";
import { zSidLabel } from "src/types";
import z from "zod";

import { zObjectPermissions } from "../access/ZObjectAccess";
import { zUnsafeDataMap, zUnsafeValues } from "../attribute/ZAttrValue";
import { zEntityError } from "../error/ZEntityError";
import { zSysDataHistory } from "../sysData/ZSysData";

const zCatalogRecordActionWorkflowAssign = z.object({
  type: z.literal("workflowAssign"),
  disabled: z.boolean(),
});

const zCatalogRecordActionRedirectToWfCard = z.object({
  type: z.literal("redirectToWfCard"),
  disabled: z.boolean(),
  workflowCardId: z.string(),
});

export const zCatalogRecordAction = z.discriminatedUnion("type", [
  zCatalogRecordActionWorkflowAssign,
  zCatalogRecordActionRedirectToWfCard,
]);

export type ZCatalogRecordAction = z.infer<typeof zCatalogRecordAction>;

const zRecordClassificationClass = z.object({
  parents: zSidLabel.array().array().nullish(),
  ...zSidLabel.shape,
});

export const zRecordClassification = z.object({
  classifierId: z.string(),
  label: z.string(),
  classes: zRecordClassificationClass.array(),
});
export type ZRecordClassification = z.infer<typeof zRecordClassification>;

export const zCatalogCardWorkflowLock = z.object({
  workflowId: z.string(),
  workflowName: z.string(),
});
export type ZCatalogCardWorkflowLock = z.infer<typeof zCatalogCardWorkflowLock>;

export const zCatalogRecord = z.object({
  id: z.string(),
  displayId: z.number(),
  catalogId: z.string().nullish(), // Реально нужен только на странице RecordCardPage
  name: z.string().nullish(),
  data: zUnsafeDataMap.nullish(), // есть записи без data
  classification: zRecordClassification.array(),
  permissions: zObjectPermissions.optional(),
  actions: zCatalogRecordAction.array().nullish(),
  readonlyAttributes: z
    .string()
    .array()
    .optional()
    .describe("id атрибутов, для которых запрещены изменения"),
  workflowLock: zCatalogCardWorkflowLock.nullish(),
  ...zSysDataHistory.shape,
  errors: zEntityError.array().nullish(),
});

export type ZCatalogRecord = z.infer<typeof zCatalogRecord>;

export type CatalogRecordFilters = {
  classifierId?: string;
  classId?: string;
  query?: string;
  queryBuilderFilter?: ZFilterGroup;
};

const zRecordClassificationToSave = z.object({
  classifierId: z.string(),
  classIds: z.string().array(),
});

export const zCatalogRecordToSave = z.object({
  data: zUnsafeValues,
  classification: zRecordClassificationToSave.array(),
});

export type ZCatalogRecordToSave = z.infer<typeof zCatalogRecordToSave>;
